import { AvailableHotelAutocompletionModel } from '@/__generated';
import Spin from '@/components/Spin';
import { useDebounce } from '@/hooks/useDebounce';
import { apiSdk } from '@/httpClient';
import { GetHotelAvailableParams } from '@/pages/HotelSearch/type';
import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

interface Props {
  onChange: (value: any) => void;
  sessionId: string;
  params: GetHotelAvailableParams | undefined;
}
const SearchBox = ({ sessionId, onChange, params }: Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = React.useState<string>('');
  const inputRef = React.useRef<any>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [hotels, setHotels] = React.useState<AvailableHotelAutocompletionModel[]>([]);
  const searchValueDebounce = useDebounce(searchValue, 300);

  React.useEffect(() => {
    searchData(searchValueDebounce);
  }, [searchValueDebounce]);

  const searchData = (searchString: string) => {
    if (searchString) {
      setLoading(true);
      apiSdk.BookingService.availableHotelAutocompletion({ sessionId: sessionId, limit: 10, query: searchString, allSupplier: params?.allSuppliers })
        .then(res => {
          setHotels(res);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setHotels([]);
    }
  };
  const toggle = event => {
    if (event.target.contains(inputRef.current)) {
      setDropdownOpen(true);
    } else {
      setDropdownOpen(prevState => !prevState);
    }
  };
  const onSearchChange = (value: any) => {
    setDropdownOpen(false);
    onChange(value);
  };
  return (
    <Dropdown isOpen={dropdownOpen && !!hotels.length} toggle={toggle} tag="div" className="text-15 text-light-1 ls-2 lh-16 ">
      <DropdownToggle tag="div" className="w-100">
        <form
          className="w-100 single-field relative d-flex items-center py-10 w-100"
          onSubmit={e => {
            e.preventDefault();
            onSearchChange(inputRef.current.value);
          }}
        >
          <input
            defaultValue={params?.hotelName}
            ref={inputRef}
            onChange={() => {
              setSearchValue(inputRef.current.value);
            }}
            className="pl-50 border-light text-dark-1 h-50 rounded-8"
            placeholder="e.g. Best Western"
          />
          <button type="submit" className="absolute d-flex items-center h-full">
            <i className="icon-search text-20 px-15 text-dark-1" />
          </button>
        </form>
      </DropdownToggle>
      <DropdownMenu tag="div" className="search-box-transition shadow-2 dropdown-menu  cursor-default border-light w-100">
        <Spin loading={loading}>
          {hotels.map(hotel => {
            return (
              <div
                key={hotel.hotelCode}
                className="px-10 py-5 -bg-blue-1 link-with-hover"
                onClick={() => {
                  inputRef.current.value = hotel.hotelName;
                  onSearchChange(hotel.hotelName);
                }}
              >
                {hotel.hotelName}
              </div>
            );
          })}
        </Spin>
      </DropdownMenu>
    </Dropdown>
  );
};

export default SearchBox;
